import { Outlet, createFileRoute } from '@tanstack/react-router';
import { AuthProvider } from 'src/features/auth/contexts/AuthContext';
import { OrgProvider } from 'src/shared/contexts/OrgContext';
import { SocketProvider } from 'src/shared/contexts/SocketContext';
import { useOrgTimeout } from 'src/shared/hooks/useOrgTimeout';
import RouteAnalytics from 'src/shared/providers/RouteAnalytics';
import WithAccessControl from 'src/shared/components/utils/WithAccessControl';
import SideNav from 'src/features/navigation/navigation/SideNav';
import PendingInvites from 'src/features/navigation/pending-invites';
import NotAllowed from 'src/features/navigation/AccessDenied';
import { useHostname } from 'src/shared/contexts/HostnameContext';

export const Route = createFileRoute('/_authenticated')({
  head: () => ({
    meta: [{ title: 'Home | Tekst' }],
  }),
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AuthProvider>
      <OrgProvider>
        <SocketProvider>
          <AuthenticatedShell />
        </SocketProvider>
      </OrgProvider>
    </AuthProvider>
  );
}

function AuthenticatedShell() {
  useOrgTimeout();
  const { hostname } = useHostname();

  return (
    <>
      <RouteAnalytics />
      <WithAccessControl blockOutlookAppOnlyRole fallback={<NotAllowed />}>
        <div className="flex w-screen h-screen overflow-hidden">
          <SideNav domain={hostname} />
          <Outlet />
        </div>
      </WithAccessControl>
      <PendingInvites />
    </>
  );
}
